import {Component, OnInit} from '@angular/core';
import {TranslateService} from "../../../services/translate.service";

@Component({
    selector: 'app-buy',
    templateUrl: './buy.component.html',
    styleUrls: ['./buy.component.css']
})
export class BuyComponent implements OnInit {

    constructor(private translate: TranslateService) {
    }

    ngOnInit() {
    }

    buyBook(link: string) {
        setTimeout(() => {
          window.open(link, '_blank');
        }, 300);
    }
}
